<template>
<div class="containers">
    <div v-if="goArea == '1'" class="area-list">
        <CAlert
            v-if="success == true"
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
            </CAlert>
            <CAlert
            v-else
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:red;border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="3">
                    <input type="text" v-model="searchTitle" placeholder="Title VDP" class="form-control"/>
                </CCol>
                <CCol sm="3">
                    <input type="text" v-model="searchSpeaker" placeholder="Speaker VDP" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Mulai" v-model="searchTglMulai" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Selesai" v-model="searchTglSelesai" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4">
                </CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                </CCol>
                <CCol sm="2">
                    <CButton @click="addData()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" :data="datas" @edit="editData" @detail="detailData" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-if="goArea == '2'" class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="goArea = '1'" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <div class="headers-modal">
            <CRow>
                <CCol sm="12">
                    <div>Detail Peserta VDP</div>
                </CCol>
            </CRow>
        </div>
        <div style="padding-right:20px;padding-left:20px">
            <CRow>
                <CCol sm="2">
                    Title
                </CCol>
                <CCol sm="10">
                    : <span class="font-weight-bold">{{dataTitle}}</span>
                </CCol>
            </CRow>
            <CRow class="mt-2">
                <CCol sm="2">
                    PLN Value
                </CCol>
                <CCol sm="10">
                    : <span>{{dataPlnValue}}</span>
                </CCol>
            </CRow>
            <CRow class="mt-2">
                <CCol sm="2">
                    ICON Value
                </CCol>
                <CCol sm="10">
                    : {{dataIconValue}}
                </CCol>
            </CRow>
            <CRow class="mt-2">
                <CCol sm="2">
                    Clue
                </CCol>
                <CCol sm="10">
                    : {{dataClue}}
                </CCol>
            </CRow>
            <CRow class="mt-2">
                <CCol sm="2">
                    Speaker
                </CCol>
                <CCol sm="10">
                    : {{dataSpeaker}}
                </CCol>
            </CRow>
            <CRow class="mt-2">
                <CCol sm="2">
                    Note
                </CCol>
                <CCol sm="10">
                    : {{dataNote}}
                </CCol>
            </CRow>
            <CRow class="mt-2">
                <CCol sm="2">
                    Tanggal
                </CCol>
                <CCol sm="10">
                    : {{dataTglMulai}} - {{dataTglSelesai}}
                </CCol>
            </CRow>
            <hr/>
            <CRow class="no-gutters mt-5">
                <CCol sm="4" style="padding-right:4px">
                    <input type="text" v-model="searchDetailNama" placeholder="Nama Peserta" class="form-control"/>
                </CCol>
                <CCol sm="3" style="padding-right:4px;padding-left:4px">
                    <input type="text" v-model="searchDetailNik" placeholder="NIP Peserta" class="form-control"/>
                </CCol>
                <CCol sm="3" style="padding-right:4px;padding-left:4px">
                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Absen" v-model="searchDetailTglAbsen" class="form-control"/>
                </CCol>
                <CCol style="padding-left:4px" sm="2">
                    <CButton @click="getDataDetail()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
            <CRow class="mt-2">
                <CCol sm="6">
                    <img v-if="dataDetail.length != 0" @click="getDownload()" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                </CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="pageDetail == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePageDetail('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="pageDetail == totalPageDetail" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePageDetail('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePageDetail(pageDetail)" v-if="totalPageDetail != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="pageDetail" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="pageDetail" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPageDetail}} - {{lastPageDetail}}</span> of {{totalRowDetail}}</span>
                </CCol>
            </CRow>
            <CRow class="mt-2">
                <CCol sm="12">
                    <table>
                        <thead>
                            <tr>
                                <th class="width:25%">Nama</th>
                                <th class="width:25%">NIP</th>
                                <th class="width:25%">Tanggal Absen</th>
                                <th class="width:25%">Komentar</th>
                            </tr>
                        </thead>
                        <tbody v-if="dataDetail.length != 0">
                            <tr v-for="(item, id) in dataDetail" :key="id">
                                <td class="width:25%">{{item.nama}}</td>
                                <td class="width:45%">{{item.nik}}</td>
                                <td class="width:15%">{{item.tglAbsen}}</td>
                                <td class="width:15%">{{item.komen}}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="text-center" colspan="4">
                                    {{errorMessageDetail}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </CCol>
            </CRow>
        </div>
        <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
            <CCol class="text-right" sm="12">
                <CButton @click="goArea = '1'" style="float:right" class="btn-cancel">Kembali</CButton>
            </CCol>
        </CRow>
    </div>
    <div v-if="goArea == '3'" class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="goArea = '1'" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Title</label>
                        <input 
                            class="form-control mr-2" 
                            v-model.trim="$v.titleAdd.$model"
                            :class="{ 'is-invalid':$v.titleAdd.$error, 'is-valid': !$v.titleAdd.$invalid }"
                            placeholder="Title" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Speaker</label>
                        <input 
                            class="form-control mr-2" 
                            v-model.trim="$v.speakerAdd.$model"
                            :class="{ 'is-invalid':$v.speakerAdd.$error, 'is-valid': !$v.speakerAdd.$invalid }"
                            placeholder="Speaker" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Tanggal Mulai</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.tglMulaiAdd.$model"
                            :class="{ 'is-invalid':$v.tglMulaiAdd.$error, 'is-valid': !$v.tglMulaiAdd.$invalid }"
                            type="date"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tanggal Selesai</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.tglSelesaiAdd.$model"
                            :class="{ 'is-invalid':$v.tglSelesaiAdd.$error, 'is-valid': !$v.tglSelesaiAdd.$invalid }"
                            type="date"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>PLN Value</label>
                        <textarea 
                            class="form-control textarea" 
                            v-model.trim="$v.plnValueAdd.$model"
                            :class="{ 'is-invalid':$v.plnValueAdd.$error, 'is-valid': !$v.plnValueAdd.$invalid }"
                            placeholder="PLN Value"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>ICON Value</label>
                        <textarea 
                            class="form-control textarea" 
                            v-model.trim="$v.iconValueAdd.$model"
                            :class="{ 'is-invalid':$v.iconValueAdd.$error, 'is-valid': !$v.iconValueAdd.$invalid }"
                            placeholder="ICON Value"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Clue</label>
                        <textarea 
                            class="form-control textarea" 
                            v-model.trim="$v.clueAdd.$model"
                            :class="{ 'is-invalid':$v.clueAdd.$error, 'is-valid': !$v.clueAdd.$invalid }"
                            placeholder="Clue"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Note</label>
                        <textarea 
                            class="form-control textarea" 
                            v-model.trim="$v.noteAdd.$model"
                            :class="{ 'is-invalid':$v.noteAdd.$error, 'is-valid': !$v.noteAdd.$invalid }"
                            placeholder="Note"
                            type="text"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="goArea = '1'" type="button" style="float:left;" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton v-if="tipeAdd == 'U'" @click="deleteModal = true" style="float:left;width:200px" class="btn mr-2 btn-danger">
                    <span>Delete</span>
                </CButton>
                <CButton @click="submitForm()" style="float:left;" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
        <CModal
            size="sm"
            :centered="true"
            title="Info Delete"
            color="danger"
            :show.sync="deleteModal"
            >
            <p>Apakah anda yakin ingin menghapus data?</p>
            <CRow>
                <CCol sm="6">
                    <CButton @click="deleteModal = false" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton @click="goSave('D')" class="btn btn-danger w-100 text-center btn-danger">Ya, Hapus</CButton>
                </CCol>
            </CRow>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</div>
</template>

<script>
import Tables from '../component/tableReportVDP'
import {DataApi} from "../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
    components: {
        ModelSelect,
        Tables,
    },
    mixins: [validationMixin],
    validations: {
        clueAdd: {
            required
        },
        iconValueAdd: {
            required
        },
        noteAdd: {
            required
        },
        plnValueAdd: {
            required
        },
        speakerAdd: {
            required
        },
        tglMulaiAdd: {
            required
        },
        tglSelesaiAdd: {
            required
        },
        titleAdd: {
            required
        }
    },
    data() {
        return {
            // datas
            refreshIcon: require('../assets/menu/icon_refresh.svg'),
            moreIcon: require('../assets/menu/icon_more.svg'),
            closeIcon: require('../assets/menu/icon_close.svg'),
            backIcon: require('../assets/menu/icon_goback.svg'),
            downloadIcon: require('../assets/menu/icon_download_excel.svg'),
            dataTh: ['Title', 'PLN Value', 'Tanggal', 'Speaker', 'Action'],
            dataTd: ['title', 'plnValue', 'tanggal', 'speaker', 'action'],
            styleTable: ['125px', '75px', '75px', '75px', '75px'],
            classReload: 'reloadOff',
            datas: [],
            dataDetail: [],
            goArea: '1',
            alertMess: '',
            success: true,
            currentAlertCounter: 0,
            loading: false,

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            pageDetail: 1,
            sizeDetail: 20,
            totalRowDetail: 0,
            totalPageDetail: 1,
            firstPageDetail: 0,
            lastPageDetail: 0,

            // filter
            searchTitle: '',
            searchSpeaker: '',
            searchTglMulai: '',
            searchTglSelesai: '',

            searchDetailNama: '',
            searchDetailNik: '',    
            searchDetailTglAbsen: '',   

            // error
            errorMessage: '',     
            errorMessageDetail: '',
            

            // data
            dataAktif: '',
            dataClue: '',
            dataIconValue: '',
            dataNote: '',
            dataPlnValue: '',
            dataSpeaker: '',
            dataTglMulai: '',
            dataTglSelesai: '',
            dataTitle: '',
            dataUnix: '',

            // add or edit
            aktifAdd: '',
            clueAdd: '',
            iconValueAdd: '',
            noteAdd: '',
            plnValueAdd: '',
            speakerAdd: '',
            tglMulaiAdd: '',
            tglSelesaiAdd: '',
            tipeAdd: 'C',
            titleAdd: '',
            unixAdd: '',

            // delete
            deleteModal: false,
            flagSearch: false,
            flagSearchDetail: false
        }
    },
    computed: {
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchTitle() {
            this.flagSearch = true
        },
        searchSpeaker() {
            this.flagSearch = true
        },
        searchTglMulai() {
            this.flagSearch = true
        },
        searchTglSelesai() {
            this.flagSearch = true
        },

        pageDetail() {
            this.getDataDetail()
        },
        searchDetailNama() {
            this.flagSearchDetail = true
        },
        searchDetailNik() {
            this.flagSearchDetail = true
        },
        searchDetailTglAbsen() {
            this.flagSearchDetail = true
        },

        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
    },
    methods: {
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.nik.toLowerCase() < b.nik.toLowerCase()) {
                        return -1
                    }
                    if (a.nik.toLowerCase() > b.nik.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.polaAbsensi.toLowerCase() < b.polaAbsensi.toLowerCase()) {
                        return -1
                    }
                    if (a.polaAbsensi.toLowerCase() > b.polaAbsensi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.wfh.toLowerCase() < b.wfh.toLowerCase()) {
                        return -1
                    }
                    if (a.wfh.toLowerCase() > b.wfh.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.wfo.toLowerCase() < b.wfo.toLowerCase()) {
                        return -1
                    }
                    if (a.wfo.toLowerCase() > b.wfo.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.mangkir.toLowerCase() < b.mangkir.toLowerCase()) {
                        return -1
                    }
                    if (a.mangkir.toLowerCase() > b.mangkir.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.dinas.toLowerCase() < b.dinas.toLowerCase()) {
                        return -1
                    }
                    if (a.dinas.toLowerCase() > b.dinas.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 7) {
                function compare(a,b) {
                    if (a.cuti.toLowerCase() < b.cuti.toLowerCase()) {
                        return -1
                    }
                    if (a.cuti.toLowerCase() > b.cuti.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 8) {
                function compare(a,b) {
                    if (a.sakit.toLowerCase() < b.sakit.toLowerCase()) {
                        return -1
                    }
                    if (a.sakit.toLowerCase() > b.sakit.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 9) {
                function compare(a,b) {
                    if (a.ijin.toLowerCase() < b.ijin.toLowerCase()) {
                        return -1
                    }
                    if (a.ijin.toLowerCase() > b.ijin.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 10) {
                function compare(a,b) {
                    if (a.nsi.toLowerCase() < b.nsi.toLowerCase()) {
                        return -1
                    }
                    if (a.nsi.toLowerCase() > b.nsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 11) {
                function compare(a,b) {
                    if (a.nso.toLowerCase() < b.nso.toLowerCase()) {
                        return -1
                    }
                    if (a.nso.toLowerCase() > b.nso.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 12) {
                function compare(a,b) {
                    if (a.telat.toLowerCase() < b.telat.toLowerCase()) {
                        return -1
                    }
                    if (a.telat.toLowerCase() > b.telat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 13) {
                function compare(a,b) {
                    if (a.cepet.toLowerCase() < b.cepet.toLowerCase()) {
                        return -1
                    }
                    if (a.cepet.toLowerCase() > b.cepet.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 14) {
                function compare(a,b) {
                    if (a.lembur.toLowerCase() < b.lembur.toLowerCase()) {
                        return -1
                    }
                    if (a.lembur.toLowerCase() > b.lembur.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 15) {
                function compare(a,b) {
                    if (a.hariKerjaKalender.toLowerCase() < b.hariKerjaKalender.toLowerCase()) {
                        return -1
                    }
                    if (a.hariKerjaKalender.toLowerCase() > b.hariKerjaKalender.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 16) {
                function compare(a,b) {
                    if (a.hariKerjaPegawai.toLowerCase() < b.hariKerjaPegawai.toLowerCase()) {
                        return -1
                    }
                    if (a.hariKerjaPegawai.toLowerCase() > b.hariKerjaPegawai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getDownload() {
            if(this.datas.length != 0) {
                let payload = {
                    komen: "",
                    limit: this.sizeDetail,
                    nama: this.searchDetailNama,
                    nik: this.searchDetailNik,
                    pageIn: this.pageDetail,
                    tglAbsen: this.searchDetailTglAbsen,
                    title: "",
                    unix: this.dataUnix
                }
                DataApi.post("/export/vdp/presensi/backoffice", payload , {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Report VDP')
                    document.body.appendChild(link)
                    link.click()
                })
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let payload = {
                aktif: "",
                limit: this.size,
                pageIn: this.page,
                speaker: this.searchSpeaker,
                tglMulai: this.searchTglMulai,
                tglSelesai: this.searchTglSelesai,
                title: this.searchTitle
            }
            DataApi.post("vdp/lihat/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        addData() {
            this.aktifAdd = ''
            this.clueAdd = ''
            this.iconValueAdd = ''
            this.noteAdd = ''
            this.plnValueAdd = ''
            this.speakerAdd = ''
            this.tglMulaiAdd = ''
            this.tglSelesaiAdd = ''
            this.titleAdd = ''
            this.totalRowAdd = ''
            this.unixAdd = ''
            this.tipeAdd = 'C'
            this.goArea = '3'
        },
        editData(val) {
            let temp = this.datas[val]
            this.aktifAdd = temp.aktif
            this.clueAdd = temp.clue
            this.iconValueAdd = temp.iconValue
            this.noteAdd = temp.note
            this.plnValueAdd = temp.plnValue
            this.speakerAdd = temp.speaker
            this.tglMulaiAdd = temp.tglMulai
            this.tglSelesaiAdd = temp.tglSelesai
            this.titleAdd = temp.title
            this.totalRowAdd = temp.totalRow
            this.unixAdd = temp.unix

            this.tipeAdd = 'U'
            this.goArea = '3'
        },
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.goSave(this.tipeAdd)
                this.loading = true
            }
        },
        goSave(tipe) {
            let payload = {
                aktif: this.aktifAdd,
                clue: this.clueAdd,
                iconValue: this.iconValueAdd,
                note: this.noteAdd,
                plnValue: this.plnValueAdd,
                speaker: this.speakerAdd,
                tglMulai: this.tglMulaiAdd,
                tglSelesai: this.tglSelesaiAdd,
                tipe: tipe,
                title: this.titleAdd,
                unix: this.unixAdd
            }
            DataApi.post("vdp/simpan/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.goArea = '1'
                this.modalDelete = false
                this.$v.$reset()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        reload() {
            this.searchSpeaker = ''
            this.searchTglMulai = ''
            this.searchTglSelesai = ''
            this.searchTitle = ''
            this.flagSearch = true
            this.getData()
            this.datas = []
            this.dataDetail = []
            this.errorMessage = 'Find Your Data'
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        movePageDetail(direction) {
            if(direction == 'prev') {
                this.pageDetail = this.pageDetail -  1
            } else {
                this.pageDetail = this.pageDetail +  1
            }
            this.getDataDetail()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        validatePageDetail(page) {
            if(page > this.totalPageDetail) {
                this.pageDetail = this.totalPageDetail
            }
        },
        detailData(val) {
            this.searchDetailNama = ''
            this.searchDetailNik = ''    
            this.searchDetailTglAbsen = ''  
            
            let generate = this.datas[val]
            this.dataAktif = generate.aktif
            this.dataClue = generate.clue
            this.dataIconValue = generate.iconValue
            this.dataNote = generate.note
            this.dataPlnValue = generate.plnValue
            this.dataSpeaker = generate.speaker
            this.dataTglMulai = generate.tglMulai
            this.dataTglSelesai = generate.tglSelesai
            this.dataTitle = generate.title
            this.dataUnix = generate.unix
            this.getDataDetail()
        },
        getDataDetail() {
            if(this.flagSearchDetail == true) {
                this.pageDetail = 1
            }
            let payload = {
                komen: "",
                limit: this.sizeDetail,
                nama: this.searchDetailNama,
                nik: this.searchDetailNik,
                pageIn: this.pageDetail,
                tglAbsen: this.searchDetailTglAbsen,
                title: "",
                unix: this.dataUnix
            }
            DataApi.post("vdp/presensi/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.dataDetail = response.data.data
                    this.totalRowDetail = response.data.totalRow
                    this.firstPageDetail = (((this.pageDetail - 1) * this.sizeDetail) + 1 )
                    this.lastPageDetail = (((this.pageDetail - 1) * this.sizeDetail) + this.dataDetail.length )
                    this.totalPageDetail = Math.floor(this.totalRowDetail/this.sizeDetail)
                    let modAr = this.totalRowDetail%this.sizeDetail
                    if(modAr != 0) {
                        this.totalPageDetail = this.totalPageDetail + 1
                    } else {
                        //
                    }
                } else {
                    this.dataDetail = []
                    this.totalRowDetail = 0
                    this.firstPageDetail = 0
                    this.lastPageDetail = 0
                    this.totalPageDetail = 1
                    this.errorMessageDetail = response.message
                }
                this.flagSearchDetail = false
                this.goArea = '2'
            })
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
    }
}
</script>
<style scoped>
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    margin-top: 20px;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.nowraps {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-title {
    font-size: 14px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:52%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:47%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:42%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:37%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:32%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:57%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete .textarea {
    background-color: white;
    margin-bottom: 20px;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-edit-submit {
    border-radius: 4px;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
</style>